import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { User } from '../../../lib/interfaces/user';
import { ROLE_RESOURCES } from '../../../lib/constants/resources.constants';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  apiUrl = environment.apiUrl;
  protected http = inject(HttpClient);
  private userSignal = signal<User[]>([]);
  role_resouces = ROLE_RESOURCES;
  private router = inject(Router);

  constructor() {}

  getUserRoles(userEmail: string) {
    return this.http.post<User[]>(`${this.apiUrl}/user`, { userEmail });
  }

  async getUserRoleAsync(userEmail: string) {
    try {
      // console.log('START USER');
      const res = await firstValueFrom(
        this.http.post<User[]>(`${this.apiUrl}/user`, { userEmail })
      );
      // console.log('END USER');
      return res;
    } catch (error) {
      // console.log('FROM AUTH');
      await this.router.navigate(['/401']);
      return;
    }
  }

  set user(value: User[]) {
    this.userSignal.set(value);
  }

  get user() {
    return this.userSignal();
  }

  canAccess(resourceName: string) {
    return this.user
      .flatMap((u) => u.role_ID)
      .flatMap((role) => this.role_resouces[role])
      .includes(resourceName);
  }
}
